import React from 'react';
import { Route } from 'react-router-dom';
import BookLayout from './BookLayout';
import BooksPage from './BooksPage';
import BookDetailPage from './BookDetailPage';
import CreateBookPage from './CreateBookPage';
import { ActivationCodePage } from '../activation-code';
import BatchDetailPage from '../activation-code/pages/BatchDetailPage';
import { 
  BookCollectionsPage, 
  BookCollectionFormPage, 
  BookCollectionDetailPage 
} from '../book-collection';

export const bookRoutes = (
  <Route path="/books" element={<BookLayout />}>
    <Route path="list" element={<BooksPage />} />
    <Route path="new" element={<CreateBookPage />} />
    <Route path=":bookId" element={<BookDetailPage />} />
    <Route path=":bookId/edit" element={<CreateBookPage />} />

    <Route path="collections" element={<BookCollectionsPage />} />
    <Route path="collections/new" element={<BookCollectionFormPage />} />
    <Route path="collections/:id" element={<BookCollectionDetailPage />} />
    <Route path="collections/:id/edit" element={<BookCollectionFormPage />} />

    <Route path="activation-codes" element={<ActivationCodePage />} />
    <Route path="activation-codes/batch/:batchId" element={<BatchDetailPage />} />
  </Route>
);

export default bookRoutes;
